// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"270":"c9a96f33","353":"78f7663a","363":"2560b447","461":"6cf3e789","488":"505009ba","601":"f66a0e5b"}[chunkId] + ".css";
};